import React from 'react'
import PropTypes from 'prop-types'

export const CourseSectionFilter = props => {
  let labelValue = `button-for-${props.filter}`
  return (
    <li className="list-unstyled">
      <input
        id={labelValue}
        name="courseSection"
        className="mr-2"
        value={props.filter}
        checked={props.filter === props.checkedFilter}
        onChange={props.handleText}
        type="radio"
      />
      <label htmlFor={labelValue}>
        {props.filter}
      </label>
    </li>
  )
}

CourseSectionFilter.propTypes = {
  filter: PropTypes.string,
  handleText: PropTypes.func,
  checkedFilter: PropTypes.string,
}
